import { render } from "./Mikomi_Month_Game.vue?vue&type=template&id=8a3a7990"
import script from "./Mikomi_Month_Game.vue?vue&type=script&lang=js"
export * from "./Mikomi_Month_Game.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__